<template>
  <div id="app">

    <div id="header" class="container">
      <ul>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#donate">Donate</a>
        </li>
        <li>
          <a href="#share">Share</a>
        </li>
        <li>
          <a href="#progress">Progress</a>
        </li>
      </ul>

      <div id="title-container">
        <carousel :per-page="1" :autoplay="true" :pagination-enabled="false" :autoplay-hover-pause="false" :autoplay-timeout="5000" :loop="true">
          <slide>
            <h2>Be a Hero</h2>
          </slide>
          <slide>
            <h2>Help a neighbor</h2>
          </slide>
          <slide>
            <h2>Itamar Hero</h2>
          </slide>
        </carousel>
      </div>
      <div id="subscribe">
        <mailchimp-subscribe
          url="https://itamarhero.us4.list-manage.com/subscribe/post-json"
          user-id="28ea00a646330feffcfc258a9"
          list-id="8cf956bf82"
          @error="onError"
          @success="onSuccess"
        >
          <template v-slot="{ subscribe, setEmail, error, success, loading }">
            <form @submit.prevent="subscribe">
              <input id="emailInput" type="email" v-model="newEmail" placeholder="email address" value="" @input="setEmail($event.target.value)" required/>
              <button id="emailButton" type="submit">Subscribe for updates!</button>
              <div class="subscribeMessage" v-if="error" v-html="error"></div>
              <div class="subscribeMessage" v-if="success">Yay! We will keep you updated.<br>Please <a class="subscribeShareLink" href="#share">share</a> and help use get this done quickly.</div>
              <div class="subscribeMessage" v-if="loading">Loading…</div>
            </form>
          </template>
        </mailchimp-subscribe>
      </div>
    </div>

    <div id='help-points' class="container">
      <div>
        <h2>Make a Donation to Help...</h2>
        <ul>
          <li>
            <img src="../assets/mountain.svg">
            Provide stability in Judea and Samaria
          </li>
          <li>
            <img src="../assets/bandaid.svg">
            Overcome a crippling tragedy
          </li>
          <li>
            <img src="../assets/plant.svg">
            Return to an organic lifestyle
          </li>
          <li>
            <img src="../assets/work.svg">
            Create jobs in Itamar
          </li>
          <li>
            <img src="../assets/egg.svg">
            Feed families healthy eggs
          </li>
        </ul>
      </div>
    </div>

    <div id="about" class="container">
      <div class="vidCollection">
        <div>
          <youtube
            v-for="vid in promoVideos"
            :key="vid"
            :video-id="vid"
            :fit-parent="true"
          />
        </div>
        <div>
          <p>Watch these videos to learn about the Zimmerman's chicken project</p>
          <img src="../assets/three_looking.jpg">
        </div>
        <div class="personalLetter">
          <p>Shalom dear friends,</p>
          <p>
            We are Alon and Rachel Zimmerman. And we have been farmers in Itamar for more than 30 years. Rachel was born in Toronto to the Diamont family and made Aliya at the age of 18. Alon was born in California to parents that had strong connections to Israel. They married in Israel and they were one of the founding families of the city of Itamar in the Shomron. Baruch Hashem, they raised a family of 10 children! and established an organic farm for the export and supplying of the local market of vegetables. In 2014 our farm was destroyed by an unusual snow storm of almost a meter of snow. We did not receive any financial assistance from the government and were very close to being financially bankrupt. We gradually picked ourselves up by setting up a small dairy farm with a variety of dairy products, selling every day house to house, including sour dough bread and fresh salads from the farm.
          </p>
          <p>
            A few years ago, We received and allotment from the government to raise 2,500 egg laying chickens. This became a great opportunity for our farm to become self-sufficient. We decided to put all our efforts in building a very modern chicken coop which is, one hand economically feasible and on the other hand very humane to the chickens. The chicken coop is two stories with the chickens living on the top floor in a clean environment not in cages. The waste falls to the bottom floor and it is periodically collected for farming use. The eggs are collected by a conveyer belt and thus cuts 50 percent of labor costs and 95 percent of the eggs are clean. We have funded, so far, more than 80 percent of the project and need another 30 thousand dollars to finish. Any form of assistance would be greatly appreciated since we have exhausted all other options of financing.
          </p>
          <p>Blessings,<br> 
            Alon and Rachel Zimmerman<br>
            Yeshuv Itamar
          </p>
        </div>
      </div>
    </div>

    <div id="donate" class="container">
      <h2>Make a Donation</h2>
      <p>Tax Deductible</p>

      <div>
        <div>
          <h3>Donate Online</h3>
          <p>Donate online with Friends of Itamar:
            <br>via <a href="http://touritamarsupportisrael.com/support-us/">paypal</a>
            <br>or other <a href="http://touritamarsupportisrael.com/donation-select/">touritamarsupportisrael.com</a>
          </p>
          <img src="../assets/rachel-computer.png">
        </div>

        <div id="check-section">
          <h3>Send a Check</h3>
          <p>Checks can be made out to <strong>Friends of Itamar</strong> and sent to: </p>
          <p id="mailing-address">Friends of Itamar<br>Attn: Zimmerman Farm<br> 1483 East 34th Street<br>Brooklyn NY 11234</p>
        </div>
      </div>
        <p>Make sure to earmark your donation: <strong>Zimmerman Farm</strong></p>
    </div>

    <div id="share" class="container">
      <h2>Please share to help...</h2>

      <social-sharing
        url="https://itamarhero.com/"
        title="Itamar Hero"
        description="Help a neighbor in the land of Israel"
        quote="The Zimmerman Organic Farm suffers a catastrophic damage. Be an Itamar Hero!"
        hashtags="itamarhero"
        twitter-user="itamarhero"
        inline-template>
        <div>
          <network network="facebook" class="shareNetwork">
            <img src="../assets/f_logo_RGB-Black_72.png" class="shareImage">
          </network>
          <network network="pinterest" class="shareNetwork">
            <img src="../assets/badgeRGB.svg" class="shareImage">
          </network>
          <network network="twitter" class="shareNetwork">
            <img src="../assets/Twitter_Social_Icon_Circle_Color.png" class="shareImage">
          </network>
          <network network="whatsapp" class="shareNetwork">
            <img src="../assets/WhatsApp_Logo_3.png" class="shareImage">
          </network>
        </div>
      </social-sharing>
    </div>

    <div id="progress">
      <h2>Progress</h2>
      <div class="progressText">
        <p>Eggs are here! We thank you all for your support helping us get this far. We still have a lot of bills to pay. But, we are overwhelmed by your kindness to us and this project.</p>
        <p>We are available to answer questions:</p>
        <div id="progressContacts">
          <div><email-icon class="mIcon" /> Email us: <b>support@itamarhero.com</b></div>
          <div><twitter-icon class="mIcon" /> Direct message us on twitter: <b>@itamarhero</b></div>
          <div><call-icon class="mIcon" /> Phone Alon Zimmerman directly: <b>+972 53-965-2067</b></div>
        </div>
      </div>
      <div class="timeline">
        Project Timeline
        <table>
          <tr>
            <td colspan="2"><b>2019</b> The project begins with a government deadline for the end of the year</td>
          <tr>
            <td class="dateTD">JAN</td>
            <td>Allotment is awarded and fundraising begins</td>
          </tr>
          <tr>
            <td class="dateTD">MAR</td>
            <td>Site is cleared, graded and crushed rock is laid</td>
          </tr>
          <tr>
            <td class="dateTD">SEP</td>
            <td> Foundation is poured</td>
          </tr>
          <tr>
            <td colspan="2"><b>2020</b> The government issues deadline extention</td>
          </tr>
          <tr>
            <td class="dateTD">JAN</td>
            <td>Steel Framing is installed, roofing and siding are ordered</td>
          </tr>
          <tr>
            <td class="dateTD">FEB</td>
            <td>Roofing is installed</td>
          </tr>
          <tr>
            <td class="dateTD">MAY</td>
            <td>Floor & Nest Kit in customs port</td>
          </tr>
          <tr>
            <td class="dateTD">NOV</td>
            <td>Parts arrive & assembly begins</td>
          </tr>
          <tr>
            <td colspan="2"><b>2021</b> Construction continues</td>
          </tr>
          <tr>
            <td class="dateTD">APR</td>
            <td>Laying Hens arrive</td>
          </tr>
        </table>
      </div>  
      <div id="progressGallery">
        <gallery :images="images" :index="index" @close="index = null"></gallery>
        <div
          class="image"
          v-for="(image, imageIndex) in images"
          :key="imageIndex"
          @click="index = imageIndex"
          :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }"
        ></div>
        <div>
          <youtube
            v-for="vid in updateVideos"
            :key="vid"
            :video-id="vid"
            :fit-parent="true"
          />
        </div>
      </div>
    </div>

    <div id="footer">
      <div id="madeBy"><a target="_blank" href="https://inkbird.io">Made by</a></div><a target="_blank" href="https://inkbird.io"><img src="../assets/inkbird_logo.svg" width="70"></a>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import EmailIcon from 'vue-material-design-icons/Email.vue';
import CallIcon from 'vue-material-design-icons/ContactPhone.vue';
import TwitterIcon from 'vue-material-design-icons/TwitterCircle.vue';
// import AlternateEmailIcon from 'vue-material-design-icons/Alternate-Email.vue';
import VueCarousel from 'vue-carousel';
import VueYouTube from 'vue-youtube';
import VueAnalytics from 'vue-analytics';
import VueGallery from 'vue-gallery';
import MailchimpSubscribe from 'vue-mailchimp-subscribe'
var SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing);
Vue.use(VueCarousel);
Vue.use(VueYouTube);
Vue.use(VueAnalytics, {
  id: 'UA-153678608-1'
});
Vue.component('email-icon', EmailIcon);
Vue.component('call-icon', CallIcon);
Vue.component('twitter-icon', TwitterIcon);
export default {
  components: {
    'gallery': VueGallery,
    MailchimpSubscribe
  },
  data() {
    return{
      newEmail: '',
      newEmailisValidFlag: '',
      promoVideos: [
        'g07t7sXIj-c',
        'XU_znZKrPyc'
      ],
      index: null,
      updateVideos: [
        '-LF1kzVfbok',
        'ON0oudLwBaY'
      ]
    }
  },
  // name: 'MyComponent',
  methods: {
    track () {
      this.$ga.page('/');
    },
    onError() {
      // handle error
    },
    onSuccess() {
      // handle success
    },
  },
  computed: {
    images() {
      let pics = []
      for (let i = 1; i <= 23; i++) {
        pics.push(`/progress/${i}.jpeg`)
      }
      return pics 
    }
  },
}
</script>
<style>@import url('.\app.css');</style>
